<template>
  <div class="no-data-wrapper">
    <aha-icon name="no-result" maintain-color />
    <div class="pt-4 font-bold text-base">
      {{ $i18nPresenter.t('couldntFindResultMatch', {
        content: getSearchContent
      }) }}
    </div>
    <div
      v-if="!isInEditor"
      class="flex justify-center mt-4 gap-1 md:gap-3"
    >
      <aha-antd-button
        class="px-2.5 sm:px-4"
        variant="secondary"
        size="lg"
        @click="request()"
        is-loading-inline
        :disabled="submitting || isComplete"
        :submitting="submitting"
      >
        <span v-if="!isComplete">{{ $i18nPresenter.t("Request") }}</span>
        <span v-else>{{ $i18nPresenter.t("Requested") }}</span>
      </aha-antd-button>
      <!-- desktop new presentation button -->
      <aha-antd-button
        v-aha-emit-action
        name="create-your-own-button"
        icon-name="add"
        class="inline"
        size="lg"
        @click="onClickNewPresentation"
      >
        <span>{{ $i18nPresenter.t("New Presentation") }}</span>
      </aha-antd-button>
    </div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import utils from '@/util'
import ApiTemplate from '@/api/template'
import CreateNewPresentationMixin from '@/mixins/presentation/CreateNewPresentationMixin'

export default {
  mixins: [CreateNewPresentationMixin],
  props: {
    keyword: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'template',
    },
    isInEditor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newPresentationTrigger: null,
      isComplete: false,
      submitting: false,
    }
  },
  computed: {
    getSearchContent() {
      if (this.keyword && this.keyword.length > 1) {
        return `"${this.keyword}".`
      }
      return this.$i18nPresenter.t('this search.')
    },
  },
  methods: {
    onClickNewPresentation() {
      this.newPresentationTrigger = 'New dropdown menu'
      this.createNewPresentation(this.newPresentationTrigger)
    },
    async request() {
      if (this.submitting) return
      this.submitting = true
      try {
        await ApiTemplate.requestTemplate({
          keyword: this.keyword,
          type: this.type,
        })
        const successMessage = this.$i18nPresenter.t('Thanks for your template request!')
        utils.showToastSuccess(successMessage)
        this.isComplete = true
        this.submitting = false
        this.$emit('request')
        utils.mixpanelTracking(
          'Templates',
          'Templates > Request Template',
          this.keyword,
        )
        const query = {
          from: 'requestTemplate',
        }
        this.$router.push({ name: 'TemplateLibrary', query })
      } catch (error) {
        Sentry.captureException(error)
        this.$emit('request')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.no-data-wrapper {
  @apply text-center relative flex flex-col items-center justify-center;
}
</style>
